import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { projectAuth } from './firebase/config';

//Bootstrap
import 'bootstrap/scss/bootstrap.scss';
import { Modal } from "bootstrap";
import './assets/css/bootstrap-icons.css';

// Directives
import ClickOutside from './click-outside';

//global styles
import './assets/css/main.css';

let app;

projectAuth.onAuthStateChanged(() => {
    if (!app) {
        app = createApp(App).directive('click-outside', ClickOutside).use(router, Modal).mount('#app');
    }
});

